import React, { useEffect, useRef, useState } from "react";
import "./GlacierPayment.module.css";
import PropTypes from "prop-types";

const GlacierPayment = ({ onSuccess, onCancel, zip, didFail, errorMessage }) => {
  const zipRef = useRef("");
  const fNameRef = useRef("");
  const lNameRef = useRef("");
  const [payFail, setPayFail] = useState(didFail);
  const [showErrorMessage, setShowErrorMessage] = useState(errorMessage);
  const submitBtnRef = useRef(null);
  const [showSpinner, setShowSpinner] = useState(false);

  const [allowSubmission, setAllowSubmission] = useState(false);
  const [ccState, setCCState] = useState(false);
  const [cvcState, setCvcState] = useState(false);
  const [ccExpState, setCcExpState] = useState(false);
  const [fnameState, setFnameState] = useState(false);
  const [lNameState, setLnameState] = useState(false);
  const [zipState, setZipState] = useState(false);

  const originalDefine = customElements.define;
  customElements.define = function (name, constructor) {
    if (name === "apple-spinner" || name === "apple-pay-modal") {
      return;
    }
    originalDefine.call(this, name, constructor);
  };

  useEffect(() => {
    if (window.CollectJS && !window.CollectJS.isConfigured) {
      try {
        window.CollectJS.configure({
          callback: (response) => {
            const paymentToken = response?.token;

            if (paymentToken && typeof onSuccess === "function") {
              submitBtnRef.current.textContent = "Submit";

              onSuccess({
                token: paymentToken,
                zip: zipRef.current,
                cardFirstName: fNameRef.current,
                cardLastName: lNameRef.current,
              });
            } else {
              if (submitBtnRef.current) {
                setShowSpinner(false);
                submitBtnRef.current.textContent = "Submit";
              }
            }
          },
          variant: "inline",
          googleFont: "Abel",
          invalidCss: {
            color: "#B40E3E",
          },
          validCss: {
            color: "#175033",
          },
          customCss: {
            "border-color": "#FFFFFF",
            "border-style": "solid",
          },
          focusCss: {
            "border-color": "#37805B",
            "border-style": "solid",
            "border-width": "3px",
          },
          fields: {
            cvv: {
              placeholder: "CVV",
            },
            ccnumber: {
              placeholder: "Credit Card",
            },
            ccexp: {
              placeholder: "MM / YY",
            },
          },
        });
        window.CollectJS.isConfigured = true;
        window.CollectJSInitialized = true;
      } catch (error) {
      }
    }

    return () => {
      const iframes = document.querySelectorAll("iframe.CollectJSInlineIframe");
      iframes.forEach((iframe) => iframe.remove());
      window.CollectJS.isConfigured = false;
      window.CollectJSInitialized = false;
    };
  }, [onSuccess]);

  useEffect(() => {
    //take over validation function defined in index.html file at glacier index init
    window.collectJsActualValidationCallback = (field, valid, message) => {
      
      //if they somehow bypass the submission block, this helps keep it in line, as this will also fire on submission to ensure the fields are validated.
      //if any of the fields turn out to be invalid, set the spinner back to false and update sub ref. then show error message.
      setShowErrorMessage(false);
      if (valid === false) {
        setShowSpinner(false);
        submitBtnRef.current.textContent = "Submit";
        // setShowErrorMessage(true);
      }

      if(field === "ccnumber"){
        if(valid === true){
          setCCState(true);
        } else {
          setCCState(false);
        }
      }
      if(field === "ccexp"){
        if(valid === true){
          setCcExpState(true);
        } else {
          setCcExpState(false);
        }
      }
      if(field === "cvv"){
        if(valid === true){
          setCvcState(true);
        } else {
          setCvcState(false);
        }
      }
    };
  
    return () => {
      //Cleanup
      window.collectJsActualValidationCallback = null;
    };
  }, []);

  useEffect(() => {
 
    //if all fields have passed collect js validation above, toggle submit button to enabled
    if(ccState === true && ccExpState === true && cvcState === true && zipState === true && fnameState === true && lNameState === true){
      setAllowSubmission(true);
    } else {
      setAllowSubmission(false);
    }

  }, [ccState, ccExpState, cvcState, zipState, fnameState, lNameState])

  useEffect(() => {
    setPayFail(didFail);

    if(didFail){
      setShowSpinner(false);
      handleShowErrorMessage();
    }
  }, [didFail]);

  const handleShowErrorMessage = async () => {
    setShowErrorMessage(true);

    await new Promise(resolve => 
      setTimeout(() => resolve({ success: true }), 6000)
    );

    setShowErrorMessage(false);
  }

  const handleFNameChange = (event) => {
    if (fNameRef && fNameRef.current !== undefined) {
      fNameRef.current = event.target.value;
      setShowErrorMessage(false);


      if(event.target.value === ""){
        setFnameState(false);
      } else {
        setFnameState(true);
      }
    } else {
    }
  };

  const handleLNameChange = (event) => {
    if (lNameRef && lNameRef.current !== undefined) {
      lNameRef.current = event.target.value;
      setShowErrorMessage(false);


      if(event.target.value === ""){
        setLnameState(false);
      } else {
        setLnameState(true);
      }
    } else {
    }
  };

  const handleZipChange = (event) => {
    if (zipRef && zipRef.current !== undefined) {
      zipRef.current = event.target.value;
      setShowErrorMessage(false);
      setZipState(true);


      if(event.target.value === ""){
        setZipState(false);
      } else {
        setZipState(true);
      }
    } else {
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const firstName = fNameRef.current;
    const lastName = lNameRef.current;
    const zipCode = zipRef.current;

    if (!firstName || !lastName || !zipCode) {
      setShowErrorMessage(true);
      return;
    }

    if (submitBtnRef.current) {
      setShowSpinner(true);
      submitBtnRef.current.textContent = "Submitting...";
    }
  };

  const handleCloseModal = () => {
    const iframes = document.querySelectorAll("iframe.CollectJSInlineIframe");
    iframes.forEach((iframe) => iframe.remove());
    window.CollectJS.isConfigured = false;
    window.CollectJSInitialized = false;
    onCancel();
  };

  return (
    <div className="container mt-5 d-flex justify-content-center mb-5">
      <div className="card" style={{ maxWidth: "500px", width: "100%" }}>
        <div className="card-body">
          <h5 className="text-center mb-4">Enter Payment Information</h5>
          <form className="theForm">
            <input type="hidden" name="variant" value="inline" />
            <input type="hidden" name="amount" value="5.00" />
            <div className="formInner">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="mb-3">
                    <label htmlFor="fname" className="form-label">
                      Cardholder First
                    </label>
                    <input
                      type="text"
                      name="fname"
                      id="fname"
                      className="form-control"
                      placeholder="Cardholder First Name"
                      onChange={handleFNameChange}
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="mb-3">
                    <label htmlFor="lname" className="form-label">
                      Cardholder Last
                    </label>
                    <input
                      type="text"
                      name="lname"
                      id="lname"
                      className="form-control"
                      placeholder="Cardholder Last Name"
                      onChange={handleLNameChange}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="ccnumber" className="form-label">
                  Card Number
                </label>
                <div
                  id="ccnumber"
                  className="form-control"
                  style={{ maxHeight: "70px" }}
                ></div>
                <div className="invalid-feedback">Field is empty</div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="ccexp" className="form-label">
                    Expiration
                  </label>
                  <div id="ccexp" className="form-control"></div>
                  <div className="invalid-feedback">Field is empty</div>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="cvv" className="form-label">
                    CVV
                  </label>
                  <div id="cvv" className="form-control"></div>
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="zip" className="form-label">
                  Zip Code
                </label>
                <input
                  type="text"
                  name="zip"
                  id="zip"
                  className="form-control"
                  placeholder="Enter Zip Code"
                  onChange={handleZipChange}
                />
              </div>

              <div className="d-flex flex-column align-items-center justify-content-center mt-4">
                {showSpinner && (
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
                {showErrorMessage && (
                  <div style={{marginBottom: "20px"}}>
                    <span style={{color: "red", fontSize: "16px"}}>Payment update failed.</span>
                  </div>
                )}
                <button
                  type="submit"
                  id="payButton"
                  className="btn btn-primary btn-lg px-5"
                  style={{ width: "75%" }}
                  ref={submitBtnRef}
                  onClick={handleFormSubmit}
                  disabled={!allowSubmission}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mt-5"
                  onClick={handleCloseModal}
                >
                  Cancel / Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

GlacierPayment.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  didFail: PropTypes.bool.isRequired,
  errorMessage: PropTypes.bool.isRequired
};

export default GlacierPayment;
